module.exports = __webpack_public_path__ + "static/media/cuando-quieres-icon.0edeb31d.svg";